import React, { useState, useEffect } from 'react'
import logo from '../../assets/virtue-logo-2.png'
import { Navbar,Nav, Form, Button, Image, Offcanvas} from 'react-bootstrap'
import { useNavigate, useLocation, NavLink,useMatch, Link } from 'react-router-dom'
import search from '../../assets/search-black.svg'
import searchGrey from '../../assets/search.svg'
import love from '../../assets/love.svg'
import basket from '../../assets/basket.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBasketShopping } from '@fortawesome/free-solid-svg-icons'
import { useAppContext } from '../../AppContext'
import user from '../../assets/user.svg'
import { trackEvent } from '../../mixpanel'
import { transformPath } from '../../App'
import home from '../../assets/home-black.svg'
import homeGreen from '../../assets/home.svg'
import { getParsedLocalStorageItem } from './Navbar'
import userRoute from "../../services/userRoute";
import { localStorageGetItem } from '../../App';
import { TbCategory, TbCategory2, TbSearch } from 'react-icons/tb'
import { IoMdSearch } from 'react-icons/io'
import { FaSearch } from 'react-icons/fa'
import productRoute from '../../services/productRoute'



const MobileNavbar =  () => {
  const {cartItems, showToast, activeCategories}= useAppContext()
  const { getUser, updateUser } = userRoute();
  const navigate = useNavigate()
  const userData = getParsedLocalStorageItem('userData');
  const token = localStorageGetItem
('userToken');
  const isLoggedIn = !!userData && !!token;

  const profileImage = userData?.profilePicture ;
  
  
  const location = useLocation();
  const isActive = (path) => {
    return location.pathname === path;
  };

  const calculateTotalItems = () => {
    return cartItems?.reduce((total, item) => total + item?.quantity, 0);
  };
  const totalItems = calculateTotalItems()

  return (
    
    <Navbar
    fixed="bottom"
    className="d-flex d-sm-none px-0 py-2 bg-white"
    style={{ boxShadow: '0px 4px 4px 0px #00000040', zIndex: '9999' }}
  >
    {[
      {
        to: '/',
        icon: <img src={isActive('/') ? homeGreen : home} alt="home icon" />,
        label: 'Home',
      },
        {
          to: '/categories',
          match: (path) => path.startsWith('/categor'),
          icon: <TbCategory2 style={{ fontSize: '1.5rem', fontWeight: '400' }} />,
          label: 'Categories',
        },
      {
        to: '/search',
        icon: <i className="bi bi-search" style={{ fontSize: '1.3rem' }}/>,
        label: 'Search',
        noTopMargin: true,
      },
      {
        to: '/cart',
        icon: (
          <div className="position-relative">
            <i className="bi bi-cart2" style={{ fontSize: '1.4rem' }} />
            {totalItems > 0 && (
          <span className="position-absolute translate-middle badge rounded-circle" style={{ padding: '3px 5px', border: '1.5px solid #FFFFFF', backgroundColor: '#CE371C',  fontSize: '9px' }}>
            {totalItems}
          </span>
        )}
          </div>
        ),
        label: 'Cart',
        noTopMargin: true,
        onClick: () => {
          trackEvent('View Cart', {
            User: userData?.email || 'Anonymous',
            clicked_at: new Date().toISOString(),
            location_clicked: transformPath(window.location.pathname),
          });
        },
      },
     
       isLoggedIn
       ? {
           to: '/dashboard',
           icon: profileImage ? (
             <Image
               roundedCircle
               src={profileImage}
               style={{
                 width: '35px',
                 height: '35px',
                 objectFit: 'cover',
               }}
             />
           ) : (
             <div
             style={{
               width: '30px',
               height: '30px',
               borderRadius: '50%',
               backgroundColor: isActive('/dashboard') ? '#469B12' : 'rgba(70, 155, 18, 0.4)',
               color:'#000000',
               display: 'flex',
               justifyContent: 'center',
               alignItems: 'center',
               fontWeight: '500',
               fontSize: '12px',
               lineHeight: '1', 
               textAlign: 'center', 
               overflow: 'visible', 
             }}
             >
               {userData?.firstName
                 ? userData.firstName[0].toUpperCase()
                 : userData.email[0].toUpperCase()}
             </div>
           ),
           label: 'Profile',
         }
       : {
           to: '/dashboard',
           icon: <i className="bi bi-person" style={{ fontSize: '1.3rem' }} />,
           label: 'Account',
           noTopMargin:true,
         },
     
     
    ].map(({ to, icon, label, match, noTopMargin = false, onClick }, idx) => {
      const active = match ? match(location.pathname) : isActive(to);
      return (
      <NavLink
      key={idx}
      to={to}
      onClick={onClick}
      className="d-flex flex-column align-items-center text-decoration-none"
      style={{
        flex: 1, // ✅ Equal width
        textAlign: 'center', // ✅ Center everything
      }}
    >

        <div style={{ color: active ? '#469B12' : '#000000' }}>
          {React.cloneElement(icon, {
            style: {
              ...(icon.props?.style || {}),
              color: active ? '#469B12' : '#000000',
            },
          })}
        </div>
        <p
          className={`m-0 ${!noTopMargin ? 'mt-1' : ''}`}
          style={{
            fontSize: '11px',
            color: active ? '#469B12' : '#000000',
          }}
        >
          {label}
        </p>
      </NavLink>
      );
    })}
  </Navbar>
  
  
  
   
  )
}

export default MobileNavbar

